function convertCmToPx(cm) {
  const pxPerCm = 37.7952755906; // 1 cm = 37.7952755906 pixels
  return cm * pxPerCm;
}

function convertCmToPxWithScaling(cm , scalingFactor) {
    const px = convertCmToPx(cm);
    return px * scalingFactor;
}

function convertPxToCm(px) {
    const cmPerPx = 1 / 37.7952755906; // 1 pixel = 0.0264583333 cm
    return px * cmPerPx;
}

function convertPxToCmWithScaling(px, scalingFactor) {
    const cm = convertPxToCm(px);
    return cm / scalingFactor;
}

function convertMMtoPx(mm) {
    const pxPerMM = 3.77952755906; // 1 mm = 3.77952755906 pixels
    return mm * pxPerMM;
}

function convertMMtoPxWithScaling(mm, scalingFactor) {
    const pxPerMM = 3.77952755906; // 1 mm = 3.77952755906 pixels
    const px = convertMMtoPx(mm);
    return px * scalingFactor;
}

function isNumber(value) {
    if (typeof value !== 'string') return false;
    // Usuwa białe znaki z początku i końca
    const trimmed = value.trim();
    // Sprawdza, czy nie jest pusty i czy jest liczbą
    return trimmed !== '' && !isNaN(Number(trimmed));
}

function checkIfSingIsAllowed(letter, configContext) {
    const allowedSpecialChars = ['+', '*'];

    // Sprawdź czy letter jest cyfrą
    if (isNumber(letter)) {
        return !!configContext.allowedNumbers;
    }

    // Sprawdź czy letter jest znakiem specjalnym
    if (allowedSpecialChars.includes(letter)) {
        return !!configContext.allowedSpecial;
    }

    // Sprawdź czy letter jest małą literą (ale nie cyfrą ani znakiem specjalnym)
    if (
        letter === letter.toLowerCase() &&
        letter !== letter.toUpperCase()
    ) {
        return !!configContext.allowedSmallLetters;
    }

    // Sprawdź czy letter jest dużą literą (ale nie cyfrą ani znakiem specjalnym)
    if (
        letter === letter.toUpperCase() &&
        letter !== letter.toLowerCase()
    ) {
        return !!configContext.allowedBigLetters;
    }

    // Jeśli żaden warunek nie jest spełniony
    return false;
}

export {
    convertCmToPx,
    convertCmToPxWithScaling,
    convertPxToCm,
    convertPxToCmWithScaling,
    convertMMtoPxWithScaling,
    convertMMtoPx,
    isNumber,
    checkIfSingIsAllowed
};